module.exports = __webpack_public_path__ + "img/individual_dateofbirth.94c54573.svg";